import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	pageUntitledDraft: {
		id: 'linkCreate.CreateConfluencePage.create.page.untitled.draft',
		defaultMessage: 'Draft: Untitled',
		description: 'Place holder text when default Parent Page has no title',
	},
});
